export const CLIENT_STATUSES = {
  initial: 'initial',
  regular: 'regular',
};
